import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableProfileRoutes = Loadable(
  './ProfileRoutes',
  () => import(/* webpackChunkName: "Profile" */ './ProfileRoutes'),
  () => [(require as any).resolveWeak('./ProfileRoutes')]
);
